import consumer from "./consumer";

let subscription = null;

export function subscribeToMessageThread(threadId, currentUserId) {
  unsubscribeFromMessageThread();

  subscription = consumer.subscriptions.create(
    { channel: "MessageThreadChannel", thread_id: threadId },
    {
      received(data) {
        if (data.type === "new_message" && data.sender_id !== currentUserId) {
          const container = document.getElementById("chat-messages");
          if (!container) return;

          // Skip if message already exists (deduplication)
          if (document.getElementById(`message_${data.message_id}`)) return;

          container.insertAdjacentHTML("beforeend", data.html);
          container.scrollTop = container.scrollHeight;
        }
      }
    }
  );
}

export function unsubscribeFromMessageThread() {
  if (subscription) {
    subscription.unsubscribe();
    subscription = null;
  }
}
